module.exports = __webpack_public_path__ + "img/chat.625e8f78.png";